<template>
  <div>
    <el-card>
      <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
        <el-tab-pane :label="$t('list')" name="0">
          <student-list v-if="activeTab == 0"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('manage')" name="1" v-if="false">
          <student-statistics/>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import StudentList from './studentList'// 学生列表component
import StudentStatistics from './studentStatistics'
export default {
  components: {
    StudentList,
    StudentStatistics
  },
  data() {
    return {
      activeTab: '0'
    }
  },
  methods: {
    handleClick() {

    }
  }
}
</script>
<i18n lang="yaml">
en:
  list: Student listing
  manage: Student statistics
zh-CN:
  list: 学生列表
  manage: 学生统计
zh-TW:
  list: 學生列表
  manage: 學生統計
it:
  list: Elenco degli studenti
  manage: Statistiche degli studenti
id:
  list: Daftar Siswa
  manage: Statistik Siswa
</i18n>
